'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _functional = require('../utils/functional');

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _class = function _class(el) {
  var _this = this;

  (0, _classCallCheck3.default)(this, _class);

  this.els = {
    el: el,
    cards: (0, _functional.getElements)('.blg-Card', { context: el })
  };

  var resizeCards = function resizeCards() {
    var tallestHeader = 0;

    _this.els.cards.forEach(function (card) {
      var cardContent = (0, _functional.getElement)('.blg-Card_Content', { context: card });

      cardContent.style.height = 'auto';

      tallestHeader = cardContent.offsetHeight > tallestHeader ? cardContent.offsetHeight : tallestHeader;
    });

    if (window.innerWidth > _utils.mediaBreakpoints.sm) {
      _this.els.cards.forEach(function (card) {
        var cardContent = (0, _functional.getElement)('.blg-Card_Content', { context: card });

        cardContent.style.height = tallestHeader + 'px';
      });
    }
  };

  window.setTimeout(function () {
    resizeCards();
  }, 500);

  window.addEventListener('resize', (0, _utils.debounce)(resizeCards, 50));
};

exports.default = _class;